/**
 * @fileoverview GET handler for the "/apps/app_groups_with_permission" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupsWithPermissionCacheKeys } from "./constants";
import type { AppsAppGroupsWithPermissionResult, GetAppsAppGroupsProps } from "./types";

export const getAppsAppGroupsWithPermission = reactQueryFetcherAdapter(
  appsAppGroupsWithPermissionCacheKeys,
  (signal: AbortSignal, { permission }: GetAppsAppGroupsProps): Promise<AppsAppGroupsWithPermissionResult> => {
    return fetch(`/apps/app_groups_with_permission/${permission}`, "GET", {}, { signal });
  }
);
